import React from "react";
import CSSModules from "lib/utils/css-modules";

import { Button, Form, FormControl, Grid, AppSettings, st } from "lib/index";
import { iframeCode } from "./StWidget";
import WidgetRouteFormSection, { buildRouteParams } from "./WidgetRouteFormSection";
import styles from "./WidgetsSettingsView.less";

@CSSModules(styles)
export default class IframeWidgetView extends React.PureComponent {
  constructor(...args) {
    super(...args);
    const { company, products, marketplace } = this.props;
    this.state = {
      showCode: false,
      routeParams: buildRouteParams({ company, products, marketplace }),
      width: "100%",
      height: 600,
      locale: null,
      currency: null,
    };
  }

  render() {
    const { company, products, marketplace } = this.props;
    const { showCode, routeParams, width, height, locale, currency } = this.state;
    const iframeUrl = routeParams.url && st.addQueryParamsToUrl(routeParams.url, { _iframe: "1" });

    return (
      <div styleName="widget-container">
        <div styleName="widget-form">
          <Form>
            <h3>{I18n.t("papp.settings.IframeWidgetView.title")}</h3>

            <WidgetRouteFormSection
              company={company}
              products={products}
              marketplace={marketplace}
              locale={locale}
              currency={currency}
              value={routeParams}
              onChange={(routeParams) => this.setState({ routeParams })}
            />

            <FormControl.LocaleSelectFormGroup
              inlineLabel
              label={I18n.t("papp.settings.WidgetsSettingsView.locale")}
              value={locale}
              onChange={(locale) => this.setState({ locale })}
              locales="customer_locales"
              includeBlank
              placeholder={I18n.t("papp.settings.WidgetsSettingsView.detect_from_visitor_browser")}
            />

            <FormControl.SelectFormGroup
              inlineLabel
              label={I18n.t("papp.settings.WidgetsSettingsView.currency")}
              value={currency}
              onChange={(currency) => this.setState({ currency })}
              options={AppSettings.frontend_currencies.filter((currency) => !["GBP", "TRY"].includes(currency))}
              includeBlank
              placeholder={I18n.t("papp.settings.WidgetsSettingsView.detect_from_visitor_browser")}
            />

            <FormControl.MoneyFormGroup
              label={I18n.t("papp.settings.IframeWidgetView.iframe_width")}
              inlineLabel
              value={
                width
                  ? `${width}`.indexOf("%") !== -1
                    ? { value: parseInt(width), currency: "%" }
                    : { value: width, currency: "px" }
                  : null
              }
              onChange={(money) =>
                this.setState({
                  width: money && money.value ? (money.currency === "px" ? money.value : `${money.value}%`) : null,
                })
              }
              currencies={["%", "px"]}
            />

            <FormControl.MoneyFormGroup
              label={I18n.t("papp.settings.IframeWidgetView.iframe_height")}
              inlineLabel
              value={
                height
                  ? `${height}`.indexOf("%") !== -1
                    ? { value: parseInt(height), currency: "%" }
                    : { value: height, currency: "px" }
                  : null
              }
              onChange={(money) =>
                this.setState({
                  height: money && money.value ? (money.currency === "px" ? money.value : `${money.value}%`) : null,
                })
              }
              currencies={["%", "px"]}
            />

            <Button
              primary
              as="a"
              onClick={() => this.setState({ showCode: !showCode })}
              content={I18n.t("papp.settings.IframeWidgetView.generate_code")}
            />
          </Form>
        </div>

        {showCode && (
          <div styleName="widget-code">
            <p>{I18n.t("papp.settings.IframeWidgetView.put_widget_anywhere")}</p>
            <FormControl.TextArea
              disabled="disabled"
              style={{ width: "600px" }}
              rows="5"
              value={iframeCode({ url: iframeUrl, width, height })}
            />
          </div>
        )}

        <hr />

        {iframeUrl && (
          <div styleName="widget-example">
            <h3>{I18n.t("papp.settings.IframeWidgetView.preview")}</h3>
            <iframe src={iframeUrl} width={width} height={height} frameBorder="0"></iframe>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/settings/WidgetsSettingsView/IframeWidgetView.jsx